import { z } from "zod";

import { ERouteName } from "@/routeName";

export const TRANSFER_SIGNATURE_PROMPT_QUERY_PARAM = "transferSignature";
const TRANSFER_SIGNATURE_PROMPT_FLAG = "1";

type TransferSignaturePromptFlag = typeof TRANSFER_SIGNATURE_PROMPT_FLAG;

export type SubscriberAttachOrigin = "created" | "existing";

export interface AttachSuccessSituation {
  readonly origin: SubscriberAttachOrigin;
  readonly siteHasHardware: boolean;
}

export interface AttachSuccessDestination {
  readonly name: ERouteName;
  readonly query: Readonly<Partial<Record<typeof TRANSFER_SIGNATURE_PROMPT_QUERY_PARAM, TransferSignaturePromptFlag>>>;
}

export function resolveAttachSuccessDestination(situation: AttachSuccessSituation): AttachSuccessDestination {
  const shouldPromptForSignature = situation.siteHasHardware;

  if (shouldPromptForSignature) {
    return {
      name: ERouteName.SITE_DETAILS_OVERVIEW,
      query: { [TRANSFER_SIGNATURE_PROMPT_QUERY_PARAM]: TRANSFER_SIGNATURE_PROMPT_FLAG },
    };
  }

  return {
    name: ERouteName.SITE_DETAILS_OVERVIEW,
    query: {},
  };
}

const transferSignaturePromptFlagSchema = z.literal(TRANSFER_SIGNATURE_PROMPT_FLAG);

export function isTransferSignaturePromptRequested(rawQueryValue: unknown): boolean {
  return transferSignaturePromptFlagSchema.safeParse(rawQueryValue).success;
}
